module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "dm05"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractVerse",
    staticStyle: {
      "text-indent": "0%",
      "margin-left": "0%"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The eyes relay what we desire; in our hearts love lies buried.")])]), _vm._v(" "), _c('p', {
    staticClass: "extractSource",
    staticStyle: {
      "margin-left": "0%"
    }
  }, [_vm._v("—"), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("LAYLA BINT SA")]), _c('span', {
    staticClass: "smallCaps"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("D IBN MAHDI OF THE BANU")]), _vm._v(" "), _c('span', {
    staticClass: "smallCaps"
  }, [_c('img', {
    staticClass: "epubimage",
    attrs: {
      "alt": "image",
      "src": "Images/c.jpg"
    }
  }), _vm._v("AMIR"), _c('br')]), _vm._v(" (the beloved of Qays ibn al-Mulawwah, the Madman of Layla, or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Majnun Layla")]), _vm._v(") c. eighth century "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("C.E")]), _vm._v(". (from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Book of Songs,")]), _vm._v(" volume II, Abu al-Faraj al-Isfahani, d. 967 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("C.E")]), _vm._v(".)")])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "alt": "image",
      "src": "Images/t.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6f2867e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780765316578_dm05.vue
// module id = 90
// module chunks = 0